import type { GeneratedConfig, GeneratedPackageSettings } from '@ms-cloudpack/common-types';
import { sortObjectKeys } from './sortObjectKeys.js';
import { compareSettings } from '../packageSettings/compareSettings.js';

/**
 * Sorts the generated config so that we don't have unneeded changes due to differences in
 * order of operations.
 */
export function sortGeneratedConfig(generated: GeneratedConfig): void {
  const { packageSettings } = generated;
  if (!packageSettings) {
    return;
  }

  // Ensure package settings are sorted based on package name and version requirement.
  packageSettings.sort(compareSettings);

  for (let i = 0; i < packageSettings.length; i++) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const originalSetting = packageSettings[i] as Record<string, any>;
    const formattedSetting: {
      match: GeneratedPackageSettings['match'];
      [key: string]: unknown;
    } = {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      match: originalSetting.match,
    };

    for (const key of Object.keys(originalSetting).sort() as (keyof GeneratedPackageSettings)[]) {
      if (key !== 'match') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const value = originalSetting[key];
        if (Array.isArray(value)) {
          formattedSetting[key] = value.sort();
        } else if (typeof value === 'object' && value !== null) {
          formattedSetting[key] = sortObjectKeys(value);
        } else {
          formattedSetting[key] = value;
        }
      }
    }

    packageSettings.splice(i, 1, formattedSetting);
  }
}
